// Pure event type utility functions - extracted from Forecast.vue

// Canonical list of view modes backed by the events API. useWeatherData derives
// its routing from this — keep it the only definition (see #180, where a second
// copy drifted and sent the main view to /api/events).
export const EVENT_VIEW_MODES = ['festivals', 'lifestyle', 'sports'] as const

export const isEventViewMode = (mode: string): boolean =>
  EVENT_VIEW_MODES.includes(mode as any)

export const getEventTypeShortName = (eventType: string): string => {
  const typeMap: Record<string, string> = {
    'festivals': 'Festivals',
    'lifestyle': 'Lifestyle',
    'sports': 'Sports'
  }
  return typeMap[eventType] || 'Events'
}

export const getEventIcon = (eventType: string): string => {
  const iconMap: Record<string, string> = {
    'festivals': 'mdi-calendar-star',
    'lifestyle': 'mdi-palette',
    'sports': 'mdi-bike'
  }
  return iconMap[eventType] || 'mdi-calendar'
}
